const assert = (expression) => {

    if (!expression) {
        console.trace();
        throw new Error('Assertion failed!');
    }
};

module.exports = assert;

module.exports.assert = assert;
